export const images = {
  selectQuestion:
    'https://res.cloudinary.com/hbrrdozyj/image/upload/v1691160118/Technial%20Solutions/Chat_bot-pana.svg',
  chatbotNotFound:
    'https://res.cloudinary.com/hbrrdozyj/image/upload/v1691160118/Technial%20Solutions/Oops_404_Error_with_a_broken_robot-pana.svg',
};
